import { render, staticRenderFns } from "./PublishCheckResults.vue?vue&type=template&id=78a14859&scoped=true&"
import script from "./PublishCheckResults.vue?vue&type=script&lang=js&"
export * from "./PublishCheckResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a14859",
  null
  
)

export default component.exports